import type { ConversationData, CreateChatResponse, FileQuery } from '@/types/tech-qa/tech-qa';
import type { PsHttpSSE } from '@patsnap-utils/sse';

export const MaterialTechQaApi = Symbol('MaterialTechQaApi');

export interface MaterialTechQaApi {
  getConversation(conversation_id: string): Promise<ConversationData>;
  createConversation(query: string): Promise<CreateChatResponse>;
  getQueryUnderstandingStream(data: {
    query: string;
    conversation_id: string;
    file_query: FileQuery[];
  }): PsHttpSSE<string>;
  getRetrievalStream(data: Record<any, any>): PsHttpSSE<string>;
  getSummarisationStream(data: Record<any, any>): PsHttpSSE<string>;
  handleShare(conversation_id: string): Promise<Record<any, any>>;
  shareEmail(conversation_id: string, share_email: string): Promise<Record<any, any>>;
}
